import { render, staticRenderFns } from "./PaginaDistintePagamenti.vue?vue&type=template&id=89d260ec"
import script from "./PaginaDistintePagamenti.vue?vue&type=script&lang=js"
export * from "./PaginaDistintePagamenti.vue?vue&type=script&lang=js"
import style0 from "./PaginaDistintePagamenti.vue?vue&type=style&index=0&id=89d260ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports